/* eslint-disable camelcase */
import React, {Component} from 'react'
import {Container} from 'react-grid-system'
import { lighten } from 'polished'
import { Link } from 'react-router'

// STYLES
import styled from 'styled-components'

// IMAGE
import Image_2x from '../../assets/images/background-header@2x.jpg'

export default class Banner extends Component {
  constructor () {
    super()
    this.state = {isOpen: true, location: window.location.pathname}
    this.cardOpen = this.cardOpen.bind(this)
  }

  cardOpen () {
    this.setState({isOpen: false})
  }

  goTo (v) {
    if (v === 0) {
      var el = document.getElementById('more')
      window.scrollTo({ top: el.offsetTop - 80, behavior: 'smooth' })
    } else {
      setTimeout(() => {
        var el = document.getElementById('more')
        window.scrollTo({ top: el.offsetTop - 80, behavior: 'smooth' })
      }, 100)
    }
  }

  render () {
    const {t, id, type} = this.props
    return (
      <BannerContent id={id}>
        <BannerText>
          <Container>
            <Title>{t('QUALITY - Alojamento Local Qualificado')}</Title>
            {
              type === 0
                ? <span>
                  <SubTitle>{t('Programa de Qualificação e Valorização do Alojamento Local')}</SubTitle>
                  <ButtonBanner onClick={() => this.goTo(0)}>{t('Solicitar Acesso')}</ButtonBanner>
                </span>
                : <span>
                  <SubTitle>{t('Roadshow Nacional de Workshops')}</SubTitle>
                  {
                    window.location.pathname === '/'
                      ? <ButtonBanner onClick={() => this.goTo(0)}>
                        {t('Solicitar Acesso')}
                      </ButtonBanner>
                      : <Link to='/' onClick={() => this.goTo(1)}>
                        <ButtonBanner>
                          {t('Solicitar Acesso')}
                        </ButtonBanner>
                      </Link>
                  }
                </span>
            }
          </Container>
        </BannerText>
      </BannerContent>
    )
  }
}

const BannerContent = styled.div`
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: fixed;
    background-repeat: no-repeat;
    background-image:url(${Image_2x});
    position: relative;
`
const BannerText = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
`
const Title = styled.div`
    color: #FFF;
    font-family: Dosis;
    font-size: 56px;
    line-height: 71px;
    text-align: center;
    text-shadow: 0 0 20px 0 rgba(0,0,0,0.3);

    @media screen and (max-width: 767px) {
        font-size: 46px;
    }
`
const SubTitle = styled.div`
    color: #FAFAFA;
    font-family: "Source Sans Pro";
    font-size: 24px;
    font-weight: 600;
    line-height: 31px;
    text-align: center;
    text-shadow: 0 0 20px 0 rgba(0,0,0,0.3);
    margin-top: 15px;
    margin-bottom: 30px;

    @media screen and (max-width: 767px) {
        font-size: 25px;
    }

`
const ButtonBanner = styled.div`
    background-color: #2E84C6;
    padding: 15px 30px;
    border-radius: 5px;
    cursor: pointer;
    color: #FFF;
    font-family: Dosis;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    outline: none;
    transition: all 0.3s ease;
    border: none;
    max-width: 150px;
    margin-left: auto;
    margin-right: auto;
    text-decoration: none!important;

    &:hover{
        background: ${lighten(0.05, '#2E84C6')};
    }
`



// WEBPACK FOOTER //
// ./src/sections/banner/banner.section.js